import React, { useState } from "react";
import { Modal, Input } from "antd";
import { useIntl } from "react-intl";

type RenameGuideModalProps = {
  open: boolean;
  currentName: string;
  onCancel: () => void;
  onOk: (newName: string) => void;
};

const RenameGuideModal: React.FC<RenameGuideModalProps> = ({
  open,
  currentName,
  onCancel,
  onOk,
}) => {

  let intl = useIntl()
  const [name, setName] = useState(currentName);

  // Reset name when modal opens
  React.useEffect(() => {
    setName(currentName);
  }, [currentName, open]);

  return (
    <Modal
      title={intl.formatMessage({id:"planned_route"})}
      visible={open}
      okText="Ok"
      cancelText={intl.formatMessage({id:"cancel"})}
      onCancel={onCancel}
      onOk={() => {
        if (name.trim()) {
          onOk(name.trim());
        }
      }}
    >
      <Input
        value={name}
        onChange={(e) => setName(e.target.value)}
        placeholder={intl.formatMessage({id:"route_name"})}
        maxLength={128}
        autoFocus
      />
    </Modal>
  );
};

export default RenameGuideModal;
